import { render, staticRenderFns } from "./WBtnLock.vue?vue&type=template&id=6f2355f2&scoped=true&"
import script from "./WBtnLock.vue?vue&type=script&lang=js&"
export * from "./WBtnLock.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f2355f2",
  null
  
)

export default component.exports